<template>
  <div>
    <div class="item-print">
      <img
        v-if="
          bill.storeType === STORE_TYPE.DDV && !bill.storeName.includes('Vertu')
        "
        src="media/logos/bill-print-logo.png"
        width="100%"
        height="10%"
        class="heading-logo"
        alt=""
      />
      <img
        v-if="bill.storeName.includes('Vertu')"
        src="media/logos/vertu.jpg"
        width="100%"
        height="10%"
        class="heading-logo"
        alt=""
      />
      <img
        v-if="bill.storeType === STORE_TYPE.VDD"
        src="media/logos/vdd_hori_logo.png"
        width="100%"
        height="10%"
        class="heading-logo"
        alt=""
      />
      <!-- thông tin cửa hàng-->
      <div class="heading">
        <p class="bill-content">{{ storeDisplayLine }}</p>
        <p class="bill-content support-info">
          <template v-if="showDDVInfo">
            BH: 1800.6729 - HL: 1800.6306
          </template>
          <template v-else>
            Hotline: {{ getPhoneNumberByStoreType }}
          </template>
        </p>
      </div>

      <hr />

      <h5 class="text-bold text-center invoice-heading">
        Hóa Đơn Bán Hàng
      </h5>
      <p class="text-center font-size-print bill-meta">
        Số: {{ bill.billNumber }}
      </p>
      <p class="text-center font-size-print bill-meta">
        Ngày: {{ formattedBillDateTime }}
      </p>

      <hr />

      <!-- thông tin khách hàng -->
      <div class="customer font-size-print text-500">
        <div class="d-flex justify-content-between" style="width: 100%;">
          <span class="text-bold-600">Khách: {{ customerDisplayName }}</span>
          <span
            v-if="bill.customerType && bill.customerType.name && showDDVInfo"
            class="text-bold-600"
          >
            [{{ bill.customerType.name }}]
          </span>
        </div>
        <div class="d-flex justify-content-between" style="width: 100%;">
          <span class="text-title">Điện thoại</span>
          <span>{{ bill.customerPhone }}</span>
        </div>
        <div
          v-if="showDDVInfo && bill.customerId"
          class="d-flex justify-content-between"
          style="width: 100%;"
        >
          <span class="text-title">Số ID</span>
          <span class="text-bold-600">{{ bill.customerId }}</span>
        </div>
        <!-- Địa chỉ khách hàng: ẩn cả dòng khi trống; địa chỉ dài tự xuống dòng, căn phải -->
        <div
          v-if="bill.customerAddress"
          class="d-flex justify-content-between"
          style="width: 100%;"
        >
          <span class="text-title">Địa chỉ</span>
          <span
            style="
              flex: 1;
              margin-left: 8px;
              text-align: right;
              word-break: break-word;
              line-height: 1.375;
            "
            >{{ bill.customerAddress }}</span
          >
        </div>
      </div>

      <!-- sản phẩm -->
      <div class="product-section">
        <table class="product-table">
          <thead>
            <tr>
              <th class="text-left">
                <span class="text-bold-600 font-size-print">Sản phẩm</span>
              </th>
              <th class="text-center">
                <span class="text-bold-600 font-size-print">Giá niêm yết</span>
              </th>
              <th class="text-center">
                <span class="text-bold-600 font-size-print">SL</span>
              </th>
              <th class="text-right">
                <span class="text-bold-600 font-size-print">Thành tiền</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <div
              class="list-product"
              v-for="(item, index) in bill.listBillItem"
              :key="index"
            >
              <tr>
                <td colspan="4">
                  <span class="label-color font-size-print">
                    <i
                      style="color: rgb(24, 28, 50)"
                      class="fas fa-gift"
                      v-if="item.billItemType === BILL_ITEM_TYPE.PRODUCT_BONUS"
                    ></i>
                  </span>
                  <span class="bill-content font-size-print">{{
                    item.name
                  }}</span>
                </td>
              </tr>
              <tr v-if="item.imeiCode">
                <td colspan="4">
                  <span class="font-size-imei" style="font-style: italic">
                    IMEI: {{ item.imeiCode }}
                  </span>
                </td>
              </tr>
              <template v-for="(comboItem, comboIndex) in item.comboItems">
                <tr
                  v-if="formatComboChildImeiCodes(comboItem)"
                  :key="`combo-imei-${index}-${comboIndex}`"
                >
                  <td colspan="4">
                    <span class="font-size-imei" style="font-style: italic">
                      {{ comboItem.productName }} - IMEI:
                      {{ formatComboChildImeiCodes(comboItem) }}
                    </span>
                  </td>
                </tr>
              </template>
              <tr>
                <td class="text-left">
                  <span class="bill-content font-size-print"></span>
                </td>
                <td class="text-center">
                  <span
                    class="bill-content font-size-print"
                    v-if="item.billItemType === BILL_ITEM_TYPE.PRODUCT_BONUS"
                    >0</span
                  >
                  <span
                    class="bill-content font-size-print"
                    v-else-if="item.listedPrice < item.price"
                    >{{ convertPrice(item.price) }}</span
                  >
                  <span v-else class="bill-content font-size-print">{{
                    convertPrice(item.listedPrice)
                  }}</span>
                </td>
                <td class="text-center">
                  <span class="bill-content font-size-print">{{
                    item.quantity
                  }}</span>
                </td>
                <td class="text-right">
                  <span
                    class="bill-content font-size-print"
                    v-if="item.billItemType === BILL_ITEM_TYPE.PRODUCT_BONUS"
                    >0</span
                  >
                  <span
                    class="bill-content font-size-print"
                    v-else-if="item.listedPrice < item.price"
                    >{{ convertPrice(item.price * item.quantity) }}</span
                  >
                  <span
                    v-else-if="item.listedPrice >= item.price"
                    class="bill-content font-size-print"
                    >{{ convertPrice(item.listedPrice * item.quantity) }}</span
                  >
                  <span v-else class="bill-content font-size-print">{{
                    convertPrice(item.totalPrice)
                  }}</span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="bill-content font-size-print text-center"
                    >Giảm KM</span
                  >
                </td>
                <td class="text-center" colspan="2">
                  <span
                    class="bill-content font-size-print"
                    v-if="item.billItemType === BILL_ITEM_TYPE.PRODUCT_BONUS"
                  >
                    100%
                  </span>
                  <span v-else class="bill-content font-size-print">
                    {{
                      percentDiscountProduct({
                        listedPrice: item.listedPrice,
                        price: item.price,
                        quantity: item.quantity,
                        discountAmount: item.discountAmount,
                        discountType: item.discountType,
                        customerDiscountType: item.customerDiscountType,
                        customerDiscountAmount: item.customerDiscountAmount,
                      })
                    }}%</span
                  >
                </td>
                <td class="text-right">
                  <span
                    class="bill-content font-size-print"
                    v-if="item.billItemType === BILL_ITEM_TYPE.PRODUCT_BONUS"
                  >
                    0
                  </span>
                  <span v-else class="bill-content font-size-print text-center"
                    >-
                    {{
                      convertPrice(
                        actualDiscountAmount({
                          listedPrice: item.listedPrice,
                          price: item.price,
                          quantity: item.quantity,
                          discountAmount: item.discountAmount,
                          discountType: item.discountType,
                          customerDiscountType: item.customerDiscountType,
                          customerDiscountAmount: item.customerDiscountAmount,
                        }),
                      )
                    }}
                  </span>
                </td>
              </tr>
              <tr style="border-bottom: 0.5px dashed black">
                <td colspan="3"></td>
                <td class="text-right">
                  <span
                    class="bill-content font-size-print text-bold-600"
                    v-if="item.billItemType === BILL_ITEM_TYPE.PRODUCT_BONUS"
                  >
                    0
                  </span>
                  <span
                    v-else
                    class="bill-content font-size-print text-bold-600"
                    >{{ convertPrice(item.totalPrice) }}</span
                  >
                </td>
              </tr>
            </div>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="3" class="text-left">
                <span class="font-size-print">Tổng tạm tính</span>
              </td>
              <td class="text-right font-size-print text-bold-600">
                {{ convertPrice(bill.sumTotalListedPrice) }}
              </td>
            </tr>
            <tr>
              <td colspan="3" class="text-left">
                <span class="font-size-print">Giảm CK (Sản phẩm)</span>
              </td>
              <td class="text-right font-size-print text-bold-600">
                {{ formatDiscountValue(totalDiscountAmount || 0) }}
              </td>
            </tr>
            <tr v-if="showDDVInfo">
              <td colspan="3" class="text-left">
                <span class="font-size-print">
                  Giảm CK ({{
                    bill?.customerType?.name
                      ? bill?.customerType?.name?.toUpperCase()
                      : ''
                  }})
                </span>
              </td>
              <td class="text-right font-size-print text-bold-600">
                {{ formatDiscountValue(bill.sumTotalDiscountCustomer || 0) }}
              </td>
            </tr>
            <tr>
              <td colspan="3" class="text-left">
                <span class="font-size-print">Giảm CK Hóa đơn</span>
              </td>
              <td class="text-right font-size-print text-bold-600">
                {{
                  formatDiscountValue(
                    Number(bill.discountAmount) + Number(bill.pointUse),
                  )
                }}
              </td>
            </tr>
            <tr v-if="Number(bill.conversionFee) > 0">
              <td colspan="3" class="text-left">
                <span class="font-size-print">Phí chuyển đổi</span>
              </td>
              <td class="text-right font-size-print text-bold-600">
                {{ convertPrice(bill.conversionFee) }}
              </td>
            </tr>
            <tr class="total-hr-row">
              <td colspan="4">
                <hr />
              </td>
            </tr>
            <tr class="grand-total-row">
              <td colspan="3" class="text-left text-bold-600">
                TỔNG TIỀN
              </td>
              <td class="text-right text-bold-600 grand-total-value">
                {{ convertPrice(totalPay) }}đ
              </td>
            </tr>
            <tr class="font-size-print">
              <td class="text-right amount-in-words" colspan="4">
                {{ bill.textAmount }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div class="loyalty font-size-print text-500" style="width: 100%;">
        <div class="d-flex justify-content-between" style="width: 100%;">
          <span class="text-title">Tích lũy thành viên</span>
          <span>{{ convertPrice(totalPay) }}đ</span>
        </div>
      </div>

      <hr />

      <!-- QR thanh toán — layout mockup, nội dung theo SRS 3.5.2.5 -->
      <div v-if="showPaymentQR" class="payment-qr">
        <div class="payment-qr-layout">
          <div class="payment-qr-image">
            <qr-code
              v-if="isVNPayQR"
              :text="paymentQRData.image"
              :size="paymentQRSize"
              error-level="M"
            ></qr-code>
            <b-img
              v-else
              :src="'data:image/png;base64,' + paymentQRData.image"
              class="qr-payment-img"
              alt="QR thanh toán"
            />
          </div>
          <div class="payment-qr-info">
            <p class="payment-qr-title">{{ paymentQRTitle }}</p>
            <p v-if="paymentQRData.accountName" class="payment-qr-line">
              {{ paymentQRData.accountName }}
            </p>
            <p class="payment-qr-line">
              Số tiền: {{ convertPrice(paymentQRData.amount) }}đ
            </p>
            <p v-if="paymentQRTransferContent" class="payment-qr-line payment-qr-nd">
              {{ paymentQRBankLine }}
            </p>
          </div>
        </div>
        <hr />
      </div>

      <!-- thông tin người bán -->
      <div
        class="font-size-print text-500"
        style="margin-bottom: 10px; line-height: 28px"
      >
        <div class="d-flex justify-content-between">
          <span class="text-title">Tư vấn</span>
          <span>{{ bill.saleName }}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span class="text-title">Thu ngân</span>
          <span>{{ bill.cashierName }}</span>
        </div>
      </div>

      <div v-if="showDDVInfo">
        <hr />
        <!-- Ưu đãi Gói DV Hội Viên VIP — cùng kiểu khung với ô Đặc quyền thành viên -->
        <!-- Ưu đãi Gói DV Hội Viên VIP — cùng kiểu khung với ô Đặc quyền thành viên -->
        <div
          style="
            border: 2px solid #000;
            padding: 8px;
            border-radius: 8px;
            line-height: 1.6;
          "
        >
          <p class="font-size-print text-500 text-center" style="margin-bottom: 4px">
            GÓI DV HỘI VIÊN VIP
          </p>
          <ul style="color: #000; font-size: 13px; padding-left: 12px; margin-bottom: 0">
            <li>Đặc quyền nhận máy sớm</li>
            <li>
              Nhân đôi <span style="font-weight: bold">(x2)</span> Quyền lợi
              Dmember Thu cũ đổi mới cho hoá đơn sau
            </li>
            <li>
              Tặng PMH <span style="font-weight: bold">500.000đ</span> mua sản
              phẩm DJI
            </li>
            <li>
              Tặng PMH <span style="font-weight: bold">200.000đ</span> mua sản
              phẩm BEAR
            </li>
            <li>
              Giảm <span style="font-weight: bold">5%</span> khi mua Loa, Tai
              Nghe hãng JBL, SONY, Marshall
            </li>
          </ul>
        </div>

        <div
          style="
            border: 2px solid #000;
            padding: 8px;
            border-radius: 8px;
            line-height: 1.6;
            margin-top: 8px;
          "
        >
          <p class="font-size-print text-500 text-center" style="margin-bottom: 4px">
            ĐẶC QUYỀN THÀNH VIÊN – ƯU ĐÃI NGẬP TRÀN
          </p>
          <ul style="color: #000; font-size: 13px; padding-left: 12px; margin-bottom: 4px">
            <li>
              Thu cũ đổi mới: tặng thêm đến
              <span style="font-weight: bold">4.500.000đ</span>
            </li>
            <li>
              Mua sắm: Giảm đến
              <span style="font-weight: bold">5%</span>
              (Máy tính, Điện thoại, Phụ kiện công nghệ)
            </li>
            <li>
              Quà tặng: Voucher Sinh nhật đến
              <span style="font-weight: bold">500.000đ</span>
            </li>
          </ul>
          <p class="font-size-print text-500 text-center" style="margin-bottom: 0">
            Đăng ký ngay thành viên để không bỏ lỡ!
          </p>
        </div>
        <div style="border-top: 2px dotted #000; margin: 12px 0;"></div>

        <div class="dual-qr-block">
          <div class="dual-qr-col">
            <div class="dual-qr-box">
              <qr-code
                :text="linkDownloadApp"
                :size="72"
                error-level="L"
              ></qr-code>
            </div>
            <p class="dual-qr-title">Tải App DDV</p>
            <p class="dual-qr-sub">Đặc quyền - Bảo hành</p>
          </div>
          <div class="dual-qr-divider"></div>
          <div class="dual-qr-col">
            <div class="dual-qr-box">
              <qr-code
                :text="vatQRText"
                :size="72"
                error-level="M"
              ></qr-code>
            </div>
            <p class="dual-qr-title">Xuất hoá đơn GTGT</p>
            <p class="dual-qr-sub">Mã tồn tại trong 30 phút</p>
          </div>
        </div>
      </div>

      <div
        v-if="showDDVInfo"
        style="
          border: 2px solid #000;
          border-radius: 8px;
          line-height: 2;
          margin-top: 15px;
        "
      >
        <table style="width: 100%">
          <tr
            class="header-vdd"
            style="
              text-align: center;
              font-size: 14px;
              border-bottom: 2px solid #000;
              background: #000;
            "
          >
            <td style="font-weight: bold; color: #fff">VIỆN DI ĐỘNG</td>
            <td
              style="
                border-left: 2px solid #fff;
                font-weight: bold;
                color: #fff;
              "
            >
              <span>BẢO HÀNH - SỬA CHỮA</span> <br />
              <span>ĐIỆN THOẠI LAPTOP</span>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="padding: 10px; font-weight: 400">
              <ul
                style="color: rgb(0, 0, 0); font-size: 14px; padding-left: 12px"
              >
                <li>
                  Giảm thêm
                  <span style="font-weight: bold">5% đến (300,000)</span> dịch
                  vụ bảo hành sửa chữa VIỆN DI ĐỘNG
                </li>
                <li>
                  <span style="font-weight: bold">Miễn phí</span> sấy khô, kiểm
                  tra lỗi Điện Thoại - Laptop
                </li>
              </ul>
            </td>
          </tr>
        </table>
      </div>

      <hr style="margin-top: 20px !important" />
      <div class="text-align-center">
        <p class="thank-you-text">CẢM ƠN QUÝ KHÁCH!</p>
        <p class="text-styles">
          Phiếu tính tiền chỉ có giá trị xuất hóa đơn GTGT trong vòng 24h tính
          từ ngày mua hàng.<br />
          Quý khách vui lòng liên hệ Cửa hàng để cung cấp thông tin xuất hóa đơn
          GTGT.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { convertPrice } from '@/utils/common';
import {
  BILL_ITEM_TYPE,
  STORE_TYPE,
  DISCOUNT_AMOUNT_TYPE,
  DISCOUNT_AMOUNT_TYPE_STRING,
  CUSTOMER_APPELLATION,
} from '@/utils/enum';
import { CUSTOMER_APPELLATION_NAME } from '@/utils/enum-name';
import VueQRCodeComponent from 'vue-qrcode-component';
import { featureFlagMixin } from '@/view/mixins';
import { formatComboChildImeiCodes } from '@/view/pages/bills/utils/combo-imei';

const VAT_INVOICE_QR_BASE_URL = 'https://didongviet.vn/vat-invoice';

export default {
  mixins: [featureFlagMixin],
  props: ['bill', 'productUsages', 'paymentQR'],
  data() {
    return {
      DISCOUNT_AMOUNT_TYPE,
      STORE_TYPE,
      BILL_ITEM_TYPE,
      CUSTOMER_APPELLATION,
      CUSTOMER_APPELLATION_NAME,
      linkDownloadApp: 'https://ddv.onelink.me/uPCc/s8wbgntz?af_qr=true',
      paymentQRSize: 120,
      isVDDStore: this.bill.storeType === STORE_TYPE.VDD,
    };
  },
  methods: {
    convertPrice,
    formatComboChildImeiCodes,
    formatDiscountValue(amount) {
      const value = Number(amount) || 0;
      if (value <= 0) {
        return '0';
      }
      return `-${convertPrice(value)}`;
    },
    percentDiscountProduct({
      listedPrice,
      price,
      discountAmount,
      discountType,
      customerDiscountType,
      customerDiscountAmount,
      quantity,
    }) {
      if (quantity <= 0) return '0.00%';

      let finalPrice = +price;

      if (discountType === DISCOUNT_AMOUNT_TYPE.MONEY) {
        finalPrice -= +discountAmount;
      }
      if (discountType === DISCOUNT_AMOUNT_TYPE.PERCENT) {
        finalPrice -= (finalPrice * discountAmount) / 100;
      }
      if (customerDiscountType === DISCOUNT_AMOUNT_TYPE_STRING.PERCENT) {
        finalPrice -= (finalPrice * customerDiscountAmount) / 100;
      }
      if (customerDiscountType === DISCOUNT_AMOUNT_TYPE_STRING.MONEY) {
        finalPrice -= +customerDiscountAmount;
      }

      finalPrice = Math.max(0, finalPrice);

      const basePrice = Math.max(listedPrice, price);
      const totalBasePrice = basePrice * quantity;
      const totalFinalPrice = finalPrice * quantity;

      if (totalBasePrice <= 0) return '0.00';

      const discountPercentage =
        ((totalBasePrice - totalFinalPrice) / totalBasePrice) * 100;

      return Math.max(0, discountPercentage).toFixed(2);
    },
    actualDiscountAmount({
      listedPrice,
      price,
      quantity,
      discountAmount,
      discountType,
      customerDiscountType,
      customerDiscountAmount,
    }) {
      if (quantity <= 0) return 0;

      const effectiveListedPrice = listedPrice <= 0 ? price : listedPrice;
      let totalListedPrice = effectiveListedPrice * quantity;

      let finalPrice = +price;

      if (discountType === DISCOUNT_AMOUNT_TYPE.MONEY) {
        finalPrice -= +discountAmount;
      }
      if (discountType === DISCOUNT_AMOUNT_TYPE.PERCENT) {
        finalPrice -= (finalPrice * discountAmount) / 100;
      }
      if (customerDiscountType === DISCOUNT_AMOUNT_TYPE_STRING.PERCENT) {
        finalPrice -= (finalPrice * customerDiscountAmount) / 100;
      }
      if (customerDiscountType === DISCOUNT_AMOUNT_TYPE_STRING.MONEY) {
        finalPrice -= +customerDiscountAmount;
      }

      finalPrice = Math.max(0, finalPrice);
      let totalFinalPrice = finalPrice * quantity;

      if (totalFinalPrice > totalListedPrice) {
        return 0;
      }
      return totalListedPrice - totalFinalPrice;
    },
  },
  watch: {
    bill: {
      handler(newBill) {
        this.isVDDStore = newBill && newBill.storeType === STORE_TYPE.VDD;
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    formattedBillDateTime() {
      const parsed = moment(
        this.bill.createdAt,
        ['DD/MM/YYYY HH:mm', 'DD/MM/YYYY HH:mm:ss', moment.ISO_8601],
        true,
      );
      if (parsed.isValid()) {
        return parsed.format('HH:mm - DD/MM/YYYY');
      }
      return this.bill.createdAt;
    },
    customerDisplayName() {
      const appellation = this.customerAppellationText;
      const name = this.bill.customerName || '';
      if (appellation) {
        return `${appellation} ${name}`.trim();
      }
      return name;
    },
    storeDisplayLine() {
      const name = (this.bill.storeName || '').trim();
      const address = (this.bill.storeAddress || '').trim();
      if (!address) {
        return name;
      }
      if (!name) {
        return address;
      }
      const normalize = (value) =>
        value.replace(/^DDV[\s-]*/i, '').toLowerCase();
      const normalizedName = normalize(name);
      const normalizedAddress = normalize(address);
      if (
        normalizedAddress.includes(normalizedName) ||
        normalizedName.includes(normalizedAddress.split(',')[0].trim())
      ) {
        return address;
      }
      if (
        name.toLowerCase() === address.toLowerCase() ||
        address.toLowerCase().startsWith(name.toLowerCase())
      ) {
        return address;
      }
      return `${name}, ${address}`;
    },
    getPhoneNumberByStoreType() {
      return this.bill.storeHotline ? this.bill.storeHotline : '1800 6018';
    },
    totalDiscountAmount() {
      return (
        this.bill.sumTotalDiscount +
        this.bill.sumTotalDiscountListedToSellingPrice
      );
    },
    totalPay() {
      return Number(this.bill.totalPay) || 0;
    },
    isEnableHiddenDDVInfo() {
      return this.isFeatureActive('hidden-ddv-information');
    },
    showDDVInfo() {
      return !(
        (this.isVDDStore && this.isEnableHiddenDDVInfo) ||
        this.bill.storeName.includes('Vertu')
      );
    },
    customerAppellationText() {
      if (!this.bill.customerAppellation) return '';
      return CUSTOMER_APPELLATION_NAME[this.bill.customerAppellation] || '';
    },
    paymentQRData() {
      return this.paymentQR || {};
    },
    showPaymentQR() {
      return this.totalPay > 0 && !!this.paymentQRData.image;
    },
    isVNPayQR() {
      return this.paymentQRData.qrType === 'vnpay';
    },
    paymentQRTitle() {
      return this.isVNPayQR
        ? 'QUÉT MÃ VNPAY ĐỂ THANH TOÁN'
        : 'QUÉT MÃ THANH TOÁN CHUYỂN KHOẢN';
    },
    paymentQRTransferContent() {
      return this.paymentQRData.idQrcode || '';
    },
    paymentQRBankLine() {
      const transferContent = this.paymentQRTransferContent;
      return `ND: ${transferContent}`;
    },
    vatQRText() {
      return `${VAT_INVOICE_QR_BASE_URL}/${this.bill.id}`;
    },
  },
  components: {
    'qr-code': VueQRCodeComponent,
  },
};
</script>
<style lang="css" scoped>
.tab {
  position: absolute;
  left: 10em;
}

body {
  margin: 0;
  padding: 0;
}

* {
  box-sizing: border-box;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.customer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
}

.customer .text-title {
  min-width: 80px;
  display: inline-block;
  position: relative;
}

.customer .text-title::after {
  content: ':';
  position: absolute;
  right: -4px;
}

.support-info {
  font-size: 14px;
}

.invoice-heading {
  font-size: 26px;
  margin: 0;
}

.bill-meta {
  margin: 2px 0;
  color: #000;
  font-weight: 500;
}

.text-bold-600 {
  font-weight: 600;
}

.list-product {
  display: contents;
}

.heading-logo {
  object-fit: contain;
}

.bill-content {
  font-weight: 500;
  line-height: 1.6;
  color: #000000;
  margin-bottom: 0;
}

tr th {
  color: #000000;
  font-weight: 500;
}

tr td {
  color: #000000;
  font-weight: 500;
}

.heading {
  text-align: center;
  margin-bottom: 10px;
  font-size: 16px;
}

.loyalty {
  display: flex;
  margin-top: 0;
}

.loyalty .text-title {
  min-width: 160px;
  display: inline-block;
  position: relative;
}

.loyalty .text-title::after {
  content: ':';
  position: absolute;
  right: 0;
}

hr {
  border: none;
  border-top: 2px dotted black;
  color: #fff;
  background-color: #fff;
  height: 2px;
}

.product-table {
  margin: 10px 0;
  width: 100%;
}

.product-table thead tr {
  border-top: 1px dashed black;
  border-bottom: 1px dashed black;
  line-height: 35px;
}

.product-table tfoot {
  border-top: 1px dashed black;
  border-bottom: unset;
  line-height: 28px;
}

.product-table tbody tr {
  line-height: 24px;
}

.list-product tr:last-child {
  border-bottom: 1px dashed black;
}

.grand-total-row {
  font-size: 18px;
}

.total-hr-row td {
  padding: 4px 0 0;
}

.total-hr-row hr {
  margin: 0;
}

.grand-total-value {
  font-size: 18px;
}

.amount-in-words {
  font-style: italic;
  font-size: 12px;
}

.payment-qr-layout {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.payment-qr-image {
  flex-shrink: 0;
}

.payment-qr-info {
  flex: 1;
  line-height: 1.3;
  font-size: 11px;
  color: #000;
}

.payment-qr-title {
  margin: 0 0 3px;
  font-size: 11px;
  font-weight: 700;
}

.payment-qr-line {
  margin: 0;
  font-size: 11px;
}

.payment-qr-nd {
  font-size: 10px;
  word-break: break-word;
}

.dual-qr-block {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin: 10px 0;
}

.dual-qr-col {
  flex: 1;
  text-align: center;
}

.dual-qr-box {
  display: flex;
  justify-content: center;
  margin-bottom: 4px;
}

.dual-qr-divider {
  width: 1px;
  align-self: stretch;
  border-left: 2px dotted #000;
  margin: 0 8px;
}

.dual-qr-title {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #000;
}

.dual-qr-sub {
  margin: 2px 0 0;
  font-size: 11px;
  color: #000;
}

.text-bold {
  color: black;
  font-weight: 600;
}

.text-500 {
  color: black;
  font-weight: 500;
}

.text-align-center {
  text-align: center;
}

.thank-you-text {
  font-size: 15px;
  font-weight: 700;
  color: #000;
  margin: 0 0 6px;
}

.text-styles {
  color: black;
  font-size: 12.5px;
  font-weight: 500;
}

.font-size-print {
  font-size: 14px;
}

.font-size-imei {
  font-size: 13px;
  font-weight: 400;
}

.item-print {
  width: 97mm !important;
  margin-left: 16px !important;
  page-break-inside: avoid;
  overflow: visible !important;
}

.qr-payment-img {
  width: 120px;
  height: 120px;
  border: 1px solid #000;
  padding: 4px;
  object-fit: contain;
}

@media print {
  * {
    overflow: visible !important;
  }

  table,
  div tr td {
    page-break-inside: avoid;
  }

  body {
    width: 100%;
    height: auto;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  tr .header-vdd {
    background: #000 !important;
    color: white !important;
  }

  tr .header-vdd td {
    border-left: 2px solid #fff !important;
  }
}
</style>
